import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  goWmsBpjs,
  instance2,
  instanceApplicares,
} from "App/constants";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import { defaultToastError, titleModal } from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";
import { toString } from "lodash";

export const RESET_STATE_GOLONGAN_KELAS = {
  id: "",
  name: "",
  kodebridging: "",
  remark: "-",
};

export const getKetersediaanAplicare = async (id) => {
  try {
    const response = await instance2.get(
      `${LIST_URL_MASTER.golkelas_aplicares.list_ketersediaan_aplicare}?id_golongankelas=${id}`
    );

    if (response.data.status === 200) {
      return {
        state: true,
        message: "success",
        data: response.data.body,
      };
    } else {
      return {
        state: false,
        message: response.data.message,
        data: [],
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
export const getAllGolonganKelas = async (
  url = "/bed/listgolongankelasaplicares"
) => {
  try {
    const api = await instance2.get(url);
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const deleteGolonganKelasById = async (id) => {
  try {
    await instance2.post(
      LIST_URL_MASTER.golkelas_aplicares.delete,
      {},
      {
        headers: {
          idgolongankelasaplicares: id,
        },
      }
    );
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "center",
  },
  {
    id: "kodebridging",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "update_ketersediaan",
    disablePadding: false,
    label: "KETERSEDIAAN APLICARE",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const headCellsBedApplicares = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "kode_kelas",
    disablePadding: true,
    label: "KODE KELAS",
    sort: false,
    align: "center",
  },
  {
    id: "nama_kelas",
    disablePadding: true,
    label: "Nama Kelas",
    // sort: true,
    align: "center",
  },
  {
    id: "kode_ruang",
    disablePadding: false,
    label: "KODE RUANG",
    align: "center",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "nama_ruang",
    disablePadding: false,
    label: "NAMA RUANG",
    align: "center",
    minWidth: "100px",
    // sort: true,
  },
  {
    id: "kapasitas",
    disablePadding: false,
    label: "KAPASITAS",
    align: "center",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "tersedia",
    disablePadding: false,
    label: "TERSEDIA",
    align: "center",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "tersediapria",
    disablePadding: false,
    label: "TERSEDIA PRIA",
    align: "center",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "tersediawanita",
    disablePadding: false,
    label: "TERSEDIA WANITA",
    align: "center",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "tersediapriawanita",
    disablePadding: false,
    label: "TERSEDIA PRIA & WANITA",
    align: "center",
    minWidth: "120px",
    sort: false,
  },
  {
    id: "lastupdate",
    disablePadding: false,
    label: "LAST UPDATE",
    align: "center",
    minWidth: "150px",
    sort: false,
  },
];

export const ModalForm = ({
  setShowModal,
  setNewData,
  formData,
  setFormData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const addGolonganKelas = async () => {
    return instance2.post("/bed/addgolongankelasaplicares", {
      name: formData.name,
      kodebridging: formData.kodebridging,
      remark: formData.remark,
    });
  };

  const updateGolonganKelas = () => {
    return instance2.post(
      LIST_URL_MASTER.golkelas_aplicares.update,
      {
        name: formData.name,
        kodebridging: formData.kodebridging,
        remark: formData.remark,
      },
      {
        headers: {
          idgolongankelasaplicares: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "" || formData.kodebridging === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama atau Kode tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await addGolonganKelas();
        } else if (formData.id !== "") {
          await updateGolonganKelas();
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
        await setNewData();
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${titleModal(formData.id)} Golongan Kelas`}
      show={setShowModal}
    >
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="id"
            id="id"
            readOnly={true}
            value={formData.id}
          />

          <Grid item sm={12}>
            <InputTextMaster
              name="kodebridging"
              label="Kode"
              autoFocus={true}
              id="kodebridging"
              value={formData.kodebridging}
              onChange={handleChange("kodebridging")}
              placeholder="Kode"
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name="name"
              label="Nama"
              id="name"
              value={formData.name}
              onChange={handleChange("name")}
              placeholder="Nama"
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name="remark"
              label="Remark"
              id="remark"
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder="Remark"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  );
};

export const STATE_FILTER_BED = {
  search_key: "",
  pages: 1,
  limit: 500,
  kode_ppk: process.env.REACT_APP_KODE_PPK_RUJUKAN,
};


export const getListBed = async (formFilter, pages, limit) => {
  const kodeRS = process.env.REACT_APP_KODE_PPK_RUJUKAN;
  try {
    const api = await instanceApplicares.post(
      "/api/v1/rsannisa/aplicares/read/ketersediaan-kamar-rs",
      {
        start: toString(pages),
        kode_ppk: kodeRS,
        limit: toString(limit),
      }
    );
    const res = api.data;
    // console.log(res, "anu res");
    if (res.metaData?.code === 200 && res.metaData?.code_bpjs !== 401) {
      return {
        state: true,
        data: res.response?.list?.list,
        meta: {
          count: parseInt(res.metaData.totalitems),
          // pages: parseInt("1"),
          // limit: parseInt("10"),
        },
      };
    } else {
      // console.log(res, "response error");
      return {
        state: false,
        message: res.metaData?.message,
      };
    }
  } catch (error) {
    // defaultToastError("askdj");
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
